import { useEffect } from 'react';
import { useFocusRegistry } from './focusRegistry';

/**
 * Mounts an effect that mirrors `currentZoneId` into DOM attributes so CSS can
 * style the focused zone and dim the chrome of the unfocused zones.
 *   - On `.mp-app`: `data-focused-zone="<id>"` (or absent when null)
 *   - On every `[data-focus-zone]` root: `data-focus-zone-state="focused"|"unfocused"`
 *
 * Call once at the app root.
 */
export function useFocusZoneAttributes(): void {
  const currentZoneId = useFocusRegistry((s) => s.currentZoneId);
  useEffect(() => {
    const app = document.querySelector('.mp-app') as HTMLElement | null;
    if (app) {
      if (currentZoneId) app.setAttribute('data-focused-zone', currentZoneId);
      else app.removeAttribute('data-focused-zone');
    }
    const zones = document.querySelectorAll<HTMLElement>('[data-focus-zone]');
    zones.forEach((el) => {
      const id = el.getAttribute('data-focus-zone');
      el.setAttribute(
        'data-focus-zone-state',
        currentZoneId && id === currentZoneId ? 'focused' : 'unfocused',
      );
    });
  }, [currentZoneId]);
}
